export default __webpack_public_path__ + "static/media/4.3aa93bf4.jpg";